import Swiper from "swiper";
import "swiper/css";

export default class Shortcut {
  static init() {
    document.querySelectorAll(".shortcut").forEach((section) => {
      const sliderEl = section.querySelector(".shortcut__slider");
      if (!sliderEl) return;

      new Swiper(sliderEl, {
        slidesPerView: "auto", // Purely relies on our CSS calc()
        spaceBetween: 20,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
      });
    });
  }
}